import {
  allPieceTypes,
  directions,
  largePieceTypes,
  predatorPieceTypes,
} from "../const";
import { Move } from "../Move";
import {
  IPiece,
  PieceMovement,
  Position,
  PieceType,
  IMove,
  MoveType,
  ISquare,
} from "../types";
import { BaseMovement } from "./BaseMovement";

export class CraneMovement extends BaseMovement implements PieceMovement {
  capturablePieceTypes: PieceType[] = allPieceTypes.filter(
    (piece) =>
      !largePieceTypes.includes(piece) && !predatorPieceTypes.includes(piece)
  );

  getValidMoves(
    piece: IPiece,
    position: Position,
    boardState: ISquare[][],
    isLightTurn?: boolean
  ): IMove[] {
    const possibleMoves: IMove[] = [];
    const movementRange = 2;

    // ZOMBIFICATION: Zombified pieces act as the opposite color
    const effectiveIsLight = piece.zombifiedStatus.isZombified
      ? !piece.isLight
      : piece.isLight;

    for (const direction of directions) {
      for (let i = 1; i <= movementRange; i++) {
        const toPosition = {
          col: position.col + direction[0] * i,
          row: position.row + direction[1] * i,
        };

        if (!this.onBoard(boardState, toPosition)) break;

        const toSquare = boardState[toPosition.row][toPosition.col];

        // Check for special cases with multiple pieces on a square
        if (toSquare.Pieces.length > 1) {
          // Check if there's a tree on the square
          const hasTree = toSquare.Pieces.some(
            (p) => p.type === PieceType.Tree
          );

          // Check if there's a virus on the square
          const hasVirus = toSquare.Pieces.some(
            (p) => p.type === PieceType.Virus
          );

          // Get non-virus, non-tree pieces on the square
          const regularPieces = toSquare.Pieces.filter(
            (p) => p.type !== PieceType.Tree && p.type !== PieceType.Virus
          );

          // If there's at least one regular piece and it's an ally, skip this move
          if (
            regularPieces.length > 0 &&
            regularPieces[0].isLight === effectiveIsLight
          ) {
            continue; // Can't move to a square with an ally piece
          }

          // If there's a tree (tree housing case)
          if (hasTree) {
            // Find the non-tree piece in the square
            const housedPiece = toSquare.Pieces.find(
              (p) => p.type !== PieceType.Tree
            );

            if (housedPiece) {
              if (housedPiece.isLight === effectiveIsLight) {
                // If the housed piece is friendly, skip this move
                continue;
              } else if (this.capturablePieceTypes.includes(housedPiece.type)) {
                // If the housed piece is an enemy and capturable by crane, create a capture move
                possibleMoves.push(
                  new Move(piece, toPosition, MoveType.capture, housedPiece)
                );
                continue;
              } else {
                // If the housed piece is not capturable (like a bear), skip
                continue;
              }
            }
          }

          // If there's only a virus and other non-capturable pieces, skip
          continue;
        }

        // Standard single-piece square handling
        const squareInfo = this.getSquareInfo(toSquare, effectiveIsLight);
        if (squareInfo.basicSquareInfo) {
          var move = this.getMove(
            position,
            toPosition,
            squareInfo.basicSquareInfo,
            piece,
            this.capturablePieceTypes
          );

          if (move) {
            possibleMoves.push(move);
          } else if (
            squareInfo.basicSquareInfo.piece &&
            squareInfo.basicSquareInfo.piece.type === PieceType.Tree &&
            squareInfo.basicSquareInfo.piece.isLight !== effectiveIsLight
          ) {
            var houseMove = new Move(
              piece,
              toPosition,
              MoveType.house,
              squareInfo.basicSquareInfo.piece
            );
            possibleMoves.push(houseMove);
          }
        }
      }
    }

    return possibleMoves;
  }
}
